const getHoursMinSeconds = (
  seconds: number,
  shouldRound?: boolean
): { hours: number; minutes: number; seconds: number } => {
  const hour = Math.floor(seconds / 3600);
  const min = Math.floor((seconds % 3600) / 60);
  const sec = (seconds % 3600) % 60;

  return { hours: hour, minutes: min, seconds: shouldRound ? Math.ceil(sec) : sec };
};

export default getHoursMinSeconds;
